// Skillmore UI Components
import usePolling from '@empathco/ui-components/src/hooks/usePolling';
// local imports
import { DAChartStatus } from '~/graphql/types';
import { POLLING_INTERVAL } from '~/config/params';

function useChartPolling(active: boolean, failed: boolean, status?: DAChartStatus | null): number {
  return usePolling(active, failed, status === DAChartStatus.generating, POLLING_INTERVAL);
}

export default useChartPolling;
